import { useEffect, useState } from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import {
  applyTheme,
  getStoredTheme,
  toggleTheme,
  type CheckoutTheme,
} from "@/utils/theme";

export default function ThemeToggle() {
  const [theme, setTheme] = useState<CheckoutTheme>("dark");

  useEffect(() => {
    const stored = getStoredTheme();
    setTheme(stored);
    applyTheme(stored);
  }, []);

  return (
    <button
      type="button"
      onClick={() => setTheme((current) => toggleTheme(current))}
      className="flex h-11 w-11 items-center justify-center rounded-full border border-checkout-hairline bg-checkout-surface text-checkout-fg transition-colors duration-500 ease-soft hover:bg-checkout-raised"
      aria-label={
        theme === "dark" ? "Ativar tema claro" : "Ativar tema escuro"
      }
      title={theme === "dark" ? "Tema claro" : "Tema escuro"}
    >
      {theme === "dark" ? <FiSun size={18} /> : <FiMoon size={18} />}
    </button>
  );
}
